<template>
    <!--PC	-->
    <div class="main" ref="heights">
        <slot name="Page2" >

            <div style="padding-top: 50px">
                <!--                上-->
                <div style="text-align: center;width: 100vw;padding-bottom: 50px" >
                    <p style="font-weight: 600;font-size: 28px;">{{list[0]}}</p>
                    <hr class="hrLine" style="width:40px;"/> <i style="color: #db261d;font-weight: bold;font-style: normal">About</i>  <hr class="hrLine" style="width:40px;"/>
                </div>


                <div >
                    <el-row>

                        <el-col :xs="1" :sm="1" :md="2" :lg="2" :xl="2"></el-col>
                        <el-col :xs="22" :sm="22" :md="20" :lg="20" :xl="20" >
                            <el-row style="background-color: white" class="about" >
                                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="opacity: 0" :class="className2">
                                    <img style="width: 100%;height: 100%" src="../../assets/about.jpg" alt="pic1" title="pic1">
                                </el-col>
                                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="opacity: 0" :class="className">
                                    <div style="padding:40px;">
                                        <h1 style="font-weight: normal;border-bottom: 3px solid #333">致力於成爲一家磁芯行業領導者</h1>
                                        <p style="font-size: 16px;line-height: 28px;color: #333;margin-top: 20px">
                                            {{synopsis}}
                                        </p>
                                        <br/>
                                        <el-button round @click.native="this.$router.push('/About/cht')">&nbsp; {{list[1]}}<el-icon :size="12"><arrow-right-bold /></el-icon></el-button>
                                    </div>
                                </el-col>


                            </el-row>
                            <div style="padding: 50px 0" class="jianjie" :class="jieshaoAnimation">
                                <ul>
                                    <li >
                                        <h2 id="year">{{years}}</h2>
                                        <i>年</i>
                                        <p>经验</p>
                                    </li>
                                    <li >
                                        <h2 id="areas">{{areas}}</h2>
                                        <i>㎡</i>
                                        <p>車間廠房面積</p>
                                    </li>
                                    <li >
                                        <h2 id="products">1000</h2>
                                        <i>+</i>
                                        <p>產品型號</p>
                                    </li>
                                    <li >
                                        <h2 id="capacity">6000</h2>
                                        <i>吨</i>
                                        <p>產能</p>
                                    </li>
                                    <li @click="clicks" style="cursor: pointer;box-shadow: rgb(204,204,204) 0px 0px 10px;
">

                                        <h2 >100000</h2>
                                        <i>+</i>
                                        <p>庫存</p>
                                    </li>
                                    <li>
                                        <h2>

                                            <p class="animate">

                                                <span v-html="spans"
                                                      :title="spansTitle"></span>
                                            </p>

                                        </h2>
                                        <p>正在生產</p>
                                    </li>
                                </ul>

                            </div>
                        </el-col>
                    </el-row>
                </div>

                <!--                -->

            </div>
        </slot>
        <AboutDrawer ref="AboutDrawer"/>
    </div>


</template>
<script>
    import AboutDrawer from "@/ZH-CN/components/drawer";
    import request from "@/utils/request";



    export default {
        name: "Page2",

        components: {
            AboutDrawer,
        },
        data() {
            return {

                list:[],
                synopsis:[],
                title:[],
                isPC:true,
                years:40,
                areas:25000,
                spansTitle:"",
                height:0,
                spans:null,
                className: "",
                className2: "",

                jieshao:false,
                jieshaoAnimation:""




            }
        },

        methods: {
            clicks(){
                this.$refs.AboutDrawer.changeDrawer(true,"庫存數量","型號","材料","數量(只)",this.isPC)
            },

            _isMobile() {
                let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
                return flag;
            },
            NumAutoPlusAnimation(targetEle,targetNum,steps,timers){


                // byh 数字自增到某一值动画参数 、
                // targetEle 目标元素（需要动画的id属性值）
                // targetNum 目标值（最终值）
                // step 步频（最终值）
                // options={ time: 1500,num: 12000,regulator: 20}

                let options={ time: 500,num: targetNum,regulator: steps}
                options = options || {};
                var $this = document.getElementById(targetEle),
                    time = options.time || 1500, //总时间--毫秒为单位
                    finalNum = options.num || 0, //要显示的真实数值
                    regulator = options.regulator || 100, //调速器
                    step = finalNum / (time / regulator),/*每30ms增加的数值--*/
                    count = 10, //计数器
                    initial = 0;
                timers = setInterval(function () {
                    count = count + step;
                    if (count >= finalNum) {
                        clearInterval(timers);
                        count = finalNum;
                    }
                    var t = Math.floor(count);
                    if (t === initial) return;
                    initial = t;
                    $this.innerHTML = initial;
                }, 30);
            },

            //动画
            isInViewPortOfOne(){
                let that=this
                let target = document.querySelector(".about");



                const observer = new IntersectionObserver(([entry]) => {
                    if (entry.isIntersecting) {


                        that.className2="moveLeft";
                        that.className="moveRight";

                    } else {


                        // .log('元素不在可视范围内');
                    }
                }, { threshold: 0.3 }); // 阈值设置为0.1，表示元素进入可视范围10%时触发回调函数
                observer.observe(target); // 开始监听元素

                // observer.observe(target3); // 开始监听元素
            },
            isInViewPortOfTwo(){
                let that=this
                let target = document.querySelector(".jianjie");



                const observer = new IntersectionObserver(([entry]) => {
                    if (entry.isIntersecting) {
                        that.jieshao=true


                    } else {

                        that.jieshao=false
                        // .log('元素不在可视范围内');
                    }
                }, { threshold: 0.3 }); // 阈值设置为0.1，表示元素进入可视范围10%时触发回调函数
                observer.observe(target); // 开始监听元素

            },
            scrolling(){
                this.isInViewPortOfOne()
                this.isInViewPortOfTwo()
            },
            DestroyListener() {

                window.removeEventListener('scroll', this.scrolling);
            },


        },



        mounted(){


            if (this._isMobile()) {
                if(this._isMobile().indexOf("iPad")!=-1){
                    this.isPC=true;
                }else {
                    this.isPC=false;
                }

            } else {

                this.isPC=true;
            }
            request.get("/home/page2/cht").then(res =>{
                this.list = res.data[0].list;
                this.synopsis=res.data[0].synopsis;
                this.title=res.data[0].title;
            }).catch((res)=>{
            })
            request.get("/online").then(res =>{
                this.spans = res.data
                this.spansTitle= this.spans.replaceAll('<br>','\n')

            }).catch((res)=>{
            })
            //监听滚动条
            window.addEventListener("scroll", this.scrolling);
        },

        watch:{
            jieshao:{
                handler(news,old){
                    if (news==true){
                        this.jieshaoAnimation="moveUp"
                        this.NumAutoPlusAnimation("year",this.years,20,"year")
                        this.NumAutoPlusAnimation("areas",this.areas,20,"areas")
                        this.NumAutoPlusAnimation("products",1000,20,"areas")
                        this.NumAutoPlusAnimation("capacity",6000,20,"areas")


                    }

                }
            }
        }


    }
</script>

<style lang="less" scoped>


    ul{

        width: 100%;
    }
    ul li{
        display: block;
        overflow: hidden;

    }
    .hc{
        color: #db261d;
        font-style: normal;
        font-weight: bold;
    }
    .hrLine{
        vertical-align:middle; display:inline-block;
    }
    .el-button{color: #db261d;border-color: #db261d;}
    .el-button:hover{ color: white;background-color: #db261d; }
    .company{
        color: #000;
    }
    .company:hover{
        color: #666666;
        cursor: pointer;
    }

    .main{

        overflow: hidden;
    }

    @media screen and (max-width: 400px) {
        .jianjie{
            ul{
                display: -webkit-flex; /* Safari */
                -webkit-justify-content: space-between; /* Safari 6.1+ */
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                -webkit-box-pack: justify

            }
            li{
                padding-top: 10px;
                margin-top: 10px;
                text-align: center;
                width: 33%;
            }
            h2 {
                height: 1.5em;//当前字体的1.5倍
                margin: 0 auto;
                overflow: hidden;
                font-size: 1.5em !important;
                font-weight: 500;
                color: #42b983;
                font-family: 'Poppins-Regular'!important;
                display: inline-block;
            }
            i {
                font-style: normal;
                color: #42b983;
                display: inline-block;
                font-weight: bold!important;
            }
            p {
                color: #404040;
                font-size: 14px;
                line-height: 20px;
                text-align: left;
            }
            span{
                font-size: 1em !important;font-weight: 500;color: #42b983;
            }
        }
    }
    .jianjie{
        ul{
            display: -webkit-flex; /* Safari */
            -webkit-justify-content: space-between; /* Safari 6.1+ */
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            -webkit-box-pack: justify

        }
        h2 {
            height: 1.5em;//当前字体的1.5倍
            margin: 0 auto;
            overflow: hidden;
            font-size: 3em;
            font-weight: 500;
            color: #42b983;
            font-family: 'Poppins-Regular'!important;
            display: inline-block;
        }
        i {
            font-style: normal;
            color: #42b983;
            display: inline-block;
            font-weight: bold!important;
        }
        p {
            color: #404040;
            font-size: 14px;
            line-height: 20px;
            text-align: left;
        }
        span{
            font-size: 2em;font-weight: 500;color: #42b983;
        }
    }
    /*----------------------------------------------------------------*/
    .animate {
        display: block !important;
        overflow: hidden;
        animation: 15s wordsLoop linear infinite normal;
        padding: 8px 0;
        color: #42b983;
        font-weight: 500;
        font-family: 'Poppins-Regular'!important;


    }

    @-webkit-keyframes wordsLoop {
        0% {
            transform: translateY(0);
            -webkit-transform: translateY(0);
        }
        100% {
            transform: translateY(-100%);
            -webkit-transform: translateY(-100%);
        }
    }

    .animate:hover{

        animation-play-state: paused;

    }
</style>